import React from "react"

function GuaranteeIcon({ className }) {
  return (
    <svg
      className="h-full w-full"
      width="101"
      height="100"
      viewBox="0 0 101 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.3721 86.2241C82.2425 86.2241 91.8654 76.6434 91.8654 64.825C91.8654 53.0065 82.2425 43.4258 70.3721 43.4258C58.5018 43.4258 48.8789 53.0065 48.8789 64.825C48.8789 76.6434 58.5018 86.2241 70.3721 86.2241Z"
        fill="#A1C323"
        fill-opacity="0.4"
      />
      <path
        d="M45.8091 79.7068C28.2279 79.7068 13.9766 65.5179 13.9766 48.0136C13.9766 30.5092 28.2292 16.3203 45.8091 16.3203C63.389 16.3203 77.6417 30.5092 77.6417 48.0136C77.6417 58.0576 72.5069 67.0102 65.1855 72.817"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M65.1836 64.5508V72.8186H73.4877"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.8063 64.0656L29.6875 58.2298V37.8047"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.9258 42.1815V37.8047"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.8047 43.6367V64.0618L61.9235 58.2261V47.9528"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.6875 37.8047L45.8063 43.6404"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.9235 37.8047L45.8047 43.6404"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M61.9235 37.8006L45.8047 31.9648"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.6875 37.8006L45.8063 31.9648"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1345 34.8828L37.0156 40.7186V49.4722"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M51.668 53.8516V56.7694"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.0625 52.3906V55.3085"
        stroke="#2F6132"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default GuaranteeIcon
